import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36feb20f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/var/www/malayan/web/components/global/Breadcrumbs.vue').default,InformationPanel: require('/var/www/malayan/web/components/global/InformationPanel.vue').default})
